


































































import {Vue, Component, Prop} from 'vue-property-decorator';
import ColumnItem from '@/components/common/grid/ColumnItem.vue';

@Component({
  components: {ColumnItem}
})
export default class ChangeBestLayer extends Vue {
  private closePop() {
    this.$emit('closePop');
  }

  @Prop() private info!: any;
}
